import type { MailThreadDetail } from '@fos/shared/contracts/mail';
import type { ComponentType } from 'react';

/**
 * Sloty poczty dla kompozycji (bez importów innych modułów w kodzie poczty): dodatkowe akcje wątku obok „Odpowiedz”
 * (kompozycja Fali 4: „Utwórz zadanie” z wiadomości i „Zadania z wiadomości” z AI). Działa wszędzie, gdzie jest
 * `ThreadView`: podgląd maila w Inboxie, strona wątku `/poczta/:id`, wątek w profilu klienta.
 */
export interface ThreadActionsProps {
  thread: MailThreadDetail;
}

let threadActions: ComponentType<ThreadActionsProps> | null = null;

export function setThreadActions(view: ComponentType<ThreadActionsProps> | null): void {
  threadActions = view;
}

export function getThreadActions(): ComponentType<ThreadActionsProps> | null {
  return threadActions;
}
